export enum Method {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}

export class Uri {
  static init(path: string, method: Method = Method.GET, param = ''): Uri {
    const uri = new Uri();
    uri.path = path;
    uri.origin_path = path;
    uri.method = method;
    uri.param = param;
    return uri;
  }
  path = '';
  origin_path = '';
  param?: string;
  method?: Method = Method.GET;
  private querys: { key: string; value: string }[] = [];

  /**
   * 動的パラメータに値をバインドする
   * @param to
   * @param value
   */
  bindParam(value: any): Uri {
    this.path = this.path.replace(this.param!, value);
    return this;
  }

  addToken(token: string): Uri {
    this.setQuery({ token: token });
    return this;
  }

  setQuery(obj: any): Uri {
    this.querys = [];
    for (const key in obj) {
      console.log(key, obj[key]);
      this.querys.push({ key: key, value: obj[key] });
    }

    const query = this.querys.map((q) => `${q.key}=${q.value}`).join('&');
    this.path = this.origin_path + `?${query}`;
    return this;
  }
}

/**
 * URIを定義するクラス
 */
class URIsConst {
  /**
   * Root
   */
  readonly ROOT = Uri.init('/', Method.GET);
  /**
   * Main
   */
  readonly MAIN = Uri.init('/app/#', Method.GET);

  /**
   * ログインURI
   */
  readonly USERS_LOGIN = Uri.init('/v1/users/login', Method.POST);

  /**
   * ユーザー登録URI
   */
  readonly USERS_REGIST = Uri.init('/v1/users/regist', Method.POST);

  /**
   * ユーザーリストURI
   */
  readonly USERS_LIST = Uri.init('/v1/users');
  /**
   * ユーザー取得URI
   */
  readonly USERS_BYID = Uri.init('/v1/users/:user_id', Method.GET, ':user_id');

  /**
   * 教材登録URI
   */
  readonly TEACHING_MATERIAL_SAVE = Uri.init('/v1/teaching_material/save', Method.POST);

  /**
   * LINE通知接続
   */
  readonly LINE_NOTIFY_CONNECT_REDIRECT = Uri.init('/v1/line_notify_redirect');
  readonly LINE_NOTIFY_CONNECT = Uri.init('/v1/line_notify_connect', Method.GET);

  // 実施後に受け取ってリダイレクト
  readonly LINE_NOTIFY_CONNECT_STU_DONE = Uri.init('/v1/line_notify_done_stu', Method.GET);
  readonly LINE_NOTIFY_CONNECT_TEA_DONE = Uri.init('/v1/line_notify_done_tea', Method.GET);
  readonly LINE_NOTIFY_CONNECT_ADM_DONE = Uri.init('/v1/line_notify_done_adm', Method.GET);

  /**
   * LINEログイン設定
   */
  readonly LINE_AUTH_REDIRECT = Uri.init('/v1/line_auth_redirect');
  readonly LINE_AUTH = Uri.init('/v1/line_auth');
  readonly LINE_AFTER = Uri.init('/v1/line_after');
  readonly LINE_WEBHOOK = Uri.init('/v1/webhook', Method.POST);
  /**
   * メッセージLIST URI
   */
  readonly MESSAGE_LIST = Uri.init('/v1/messages');
  /**
   * メッセージの開始
   */
  readonly START_MESSAGE = Uri.init('/v1/messages/start', Method.POST);
  /**
   *
   */
  readonly LIST_ROOM_MESSAGE = Uri.init('/v1/messages/room', Method.POST);
  /**
   *
   */
  readonly APPEND_MESSAGE = Uri.init('/v1/messages/append', Method.POST);

  /**
   * 生徒関連API
   */
  readonly GET_STUDENT = Uri.init('/v1/students/:user_id', Method.GET, ':user_id');

  readonly FILE_UP = Uri.init('/v1/file/up', Method.POST);
  readonly EDITOR_FILE_UP = Uri.init('/v1/edtor_file/up', Method.POST);

  /**
   * 生徒支払いコールバック
   */
  readonly PAYMENT_CALLBACK = Uri.init('/v1/PaymentStudentService/hookPaymetDone', Method.GET);

  readonly PAYMENT_DONE_MOVE = Uri.init('/v1/Payment/DONE_MOVE', Method.POST);
  readonly PAYMENT_CANCEL_MOVE = Uri.init('/v1/Payment/CANCEL_MOVE', Method.POST);

  /**
   * 先生の給与支払いCSV
   */
  readonly KP_USER_CSV_DOWNLOAD = Uri.init('/v1/Payment/KP_USER_CSV_DOWNLOAD', Method.GET);

  /**
   * 先生の給与支払いCSV
   */
  readonly PAYMENT_CSV_DOWNLOAD = Uri.init('/v1/Payment/PAYMENT_CSV_DOWNLOAD', Method.GET);

  /**
   * 生徒のゆうちょ引落CSV
   */
  readonly YUUCHO_CSV_DOWNLOAD = Uri.init('/v1/Payment/YUUCHO_CSV_DOWNLOAD', Method.GET);

  /**
   * 生徒の請求CSV(アナザーレーン)
   */
  readonly CLAIM_CSV_DOWNLOAD = Uri.init('/v1/Payment/CLAIM_CSV_DOWNLOAD', Method.GET);

  /**
   * 生徒の請求CSV(会費ペイ)
   */
  readonly CLAIM_KP_CSV_DOWNLOAD = Uri.init('/v1/Payment/CLAIM_KP_CSV_DOWNLOAD', Method.GET);

  /**
   * 生徒の日報CSV
   */
  readonly REPORT_CSV_DOWNLOAD = Uri.init('/v1/AdminTeacher/REPORT_CSV_DOWNLOAD', Method.GET);

  /**
   * 生徒のすべてのCSV
   */
  readonly ALL_STUDENT_CSV_DOWNLOAD = Uri.init('/v1/Admin/ALL_STUDENT_CSV_DOWNLOAD', Method.GET);

  /**
   * 先生のすべてのCSV
   */
  readonly ALL_TEACHER_CSV_DOWNLOAD = Uri.init('/v1/Admin/ALL_TEACHER_CSV_DOWNLOAD', Method.GET);

  /**
   * 実績カウント用日報のCSV
   */
  readonly RESULT_REPORT_LIST_CSV_DOWNLOAD = Uri.init('/v1/Payment/RESULT_REPORT_LIST_CSV_DOWNLOAD', Method.GET);
}
export const URIs = new URIsConst();
